import { useState } from 'react';
import PageHeader from '@/components/common/PageHeader.jsx';
import Field from '@/components/common/Field.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';

const FORM_ID = 'dashboard-filters';

export default function DashboardFilters({ initialFilters, onApply, onCancel }) {
  const [form, setForm] = useState({
    desde: initialFilters?.desde ?? '',
    hasta: initialFilters?.hasta ?? '',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    onApply?.(form);
  };

  return (
    <div className="w-full">
      <PageHeader title="Filtros del dashboard" subtitle="Acotá el periodo de análisis" />
      <form id={FORM_ID} onSubmit={handleSubmit} className="mx-auto mt-6 grid w-full max-w-[600px] gap-5">
        <section className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
          <Field label="Desde" htmlFor="desde">
            <input
              id="desde"
              type="date"
              value={form.desde}
              onChange={event => setForm(prev => ({ ...prev, desde: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
          <Field label="Hasta" htmlFor="hasta">
            <input
              id="hasta"
              type="date"
              value={form.hasta}
              onChange={event => setForm(prev => ({ ...prev, hasta: event.target.value }))}
              className="w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--subpanel),0.6)] px-3 py-2 text-sm text-[rgb(var(--fg))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            />
          </Field>
        </section>
      </form>

      <StickyActions>
        <div className="flex w-full items-center justify-between gap-4">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-xl border border-[rgba(var(--border),0.6)] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--subpanel),0.6)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Cancelar
          </button>
          <button
            type="submit"
            form={FORM_ID}
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Aplicar
          </button>
        </div>
      </StickyActions>
    </div>
  );
}
